export default "__VITE_ASSET__CwP8vDdy__"